<div class="bg-blue layout-sidebar transition overflow-y-auto z-5">
  <aside aria-label="Sidebar" id="logo-sidebar" class="mt-5">
    <nav class="poseidon_nav">
      <!-- ****************************** -->
      <!-- *************** FAVORIS *************** -->
      <!-- ****************************** -->
      <div class="nav_container" *ngIf="user != null || user != undefined">
        <ul>
          <div class="mb-4">
            <!-- FAVORIS ----- -->
            <li class="uppercase text-greyLighter text-sm font-bold mb-1"
              *ngIf="!isMentorFCC && !isResponsableCertificatFCC">
              Favoris
            </li>
            <li *ngIf="!isMentorFCC && !isResponsableCertificatFCC && hideDashboard">
              <a [routerLink]="['tableau-bord']" class="nav_item" routerLinkActive="active-link">
                <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                    d="M3 8v10a1 1 0 0 0 1 1h4v-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5h4a1 1 0 0 0 1-1V8M1 10l9-9 9 9" />
                </svg>
                <span class="ml-3">Accueil</span>
              </a>
            </li>
            <li *ngIf="!hideDashboard">
              <a [routerLink]="['tableau-bord']" class="nav_item" routerLinkActive="active-link">
                <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"
                    d="M6.143 1H1.857A.857.857 0 0 0 1 1.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 7 6.143V1.857A.857.857 0 0 0 6.143 1Zm10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 17 6.143V1.857A.857.857 0 0 0 16.143 1Zm-10 10H1.857a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 7 16.143v-4.286A.857.857 0 0 0 6.143 11Zm10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286a.857.857 0 0 0 .857-.857v-4.286a.857.857 0 0 0-.857-.857Z" />
                </svg>
                <span class="ml-3">Tableau de bord</span>
              </a>
            </li>
          </div>
        </ul>
      </div>
      <!-- ****************************** -->
      <!-- *************** Contenu *************** -->
      <!-- ****************************** -->
      <ng-content *ngComponentOutlet="currentComponent"></ng-content>

      <!-- ****************************** -->
      <!-- *************** DECONNEXION *************** -->
      <!-- ****************************** -->

      <div class="nav_container" *ngIf="user != null || user != undefined">
        <ul>
          <div class="mb-4 mt-8">
            <li>
              <a style="cursor: pointer" (click)="logout()" class="nav_item">
                <svg id="Layer_1" style="enable-background: new 0 0 24 24" version="1.1" viewBox="0 0 24 24"
                  xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <style type="text/css">
                    .st0 {
                      fill: none;
                      stroke: #f3f4f6;
                      stroke-width: 1.6724;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                      stroke-miterlimit: 10;
                    }

                    .st1 {
                      fill: none;
                      stroke: #f3f4f6;
                      stroke-width: 1.5;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                      stroke-miterlimit: 10;
                    }

                    .st2 {
                      fill: none;
                      stroke: #f3f4f6;
                      stroke-width: 1.5;
                      stroke-linejoin: round;
                      stroke-miterlimit: 10;
                    }
                  </style>
                  <g>
                    <g>
                      <line class="st1" x1="7.6" x2="22" y1="12" y2="12" />
                    </g>
                    <g>
                      <path class="st1" d="M11.9,0.8H4.5C3.1,0.8,2,1.9,2,3.2v17.5c0,1.4,1.1,2.5,2.5,2.5h7.4" />
                    </g>
                    <polyline class="st1" points="18.2,8.2 22,12 18.2,15.8  " />
                  </g>
                </svg>
                <span class="ml-3 font-bold text-sm">{{ fullname }}</span>
              </a>
            </li>
            <li>
              <span class="nav_item pt-0 text-greyLighter text-sm sidebar-email">{{ email }}</span>
            </li>
          </div>
        </ul>
      </div>
    </nav>
  </aside>
</div>